import { render } from "./List.vue?vue&type=template&id=b1940b94&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=b1940b94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b1940b94"

export default script